import builder from '../builder';
import Like2 from '../../streamline-icons/bold/like-2.svg';

export default builder('IconLike2Bold', Like2);
